export const LUNA_ADVENTURE: string = "LunaAdventure";
const PREFIX: string = LUNA_ADVENTURE + ".";

// exterior
export const HIDING_SPOT_SEARCHED = PREFIX + "HidingSpotSearched";
export const ITEM_FOUND = PREFIX + "ItemFound";
export const ALL_ITEMS_FOUND = PREFIX + "AllItemsFound";
export const SCROLL_LEFT = PREFIX + "ScrollLeft";
export const SCROLL_RIGHT = PREFIX + "ScrollRight";
export const TOGGLE_HIT_AREA_RENDERER = PREFIX + "ToggleHitAreaRenderer";
export const HOME_BUTTON_PRESSED = PREFIX + "HomeButtonPressed";
export const LOCK_INPUT = PREFIX + "LockInput";
export const UNLOCK_INPUT = PREFIX + "UnlockInput";
export const HINT_BUTTON_PRESSED = PREFIX + "HintButtonPressed";
export const RESTART_IDLE_TIMER = PREFIX + "RestartIdleTimer";

// interior
export const ITEM_RETURNED = PREFIX + "ItemReturned";
export const ALL_ITEMS_RETURNED = PREFIX + "AllItemsReturned";
export const LEVEL_COMPLETE = PREFIX + "LevelComplete";
export const SHOW_CONTINUE_BUTTON = PREFIX + "ShowContinueButton";
export const PLAY_PARTICLES = PREFIX + "PlayParticles";

/** for keyboard only */
export const ITEM_SELECTED = PREFIX + "ItemSelected";
